import api from "!../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../css-loader/dist/cjs.js??clonedRuleSet-13.use[1]!../../../postcss-loader/dist/cjs.js??clonedRuleSet-13.use[2]!./select2.min.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};